import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

function RefundPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <div className="legal-header">
          <h1>Monnaify Refund Policy</h1>
          <p className="legal-meta">Last updated: 2026-04-21</p>
        </div>

        <p>
          Monnaify Pro subscriptions renew automatically until canceled. If you believe
          you were charged in error, please contact us and we will review your request.
        </p>

        <h2>Refund Requests</h2>
        <ul>
          <li>Refunds are reviewed on a case-by-case basis.</li>
          <li>We may request additional details to investigate a charge.</li>
          <li>Approved refunds are issued to the original payment method.</li>
        </ul>

        <h2>How to Contact Us</h2>
        <p>
          Please email{' '}
          <a href="mailto:info@monnaify.com">info@monnaify.com</a>{' '}
          with the account email and the reason for your request.
        </p>

        <div className="legal-actions">
          <Link to="/terms">Terms of Use</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
}

export default RefundPolicy;
